import React, { useState, useEffect } from "react";
import DashboardLayout from "../DashboardLayout";
import { useNavigate } from "react-router-dom";
import { getHomePageData } from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";
import { useAppContext } from "../../services/context";
import HomePageList from "./homePageList";

function Home_Page() {
  const { state } = useAppContext();
  const { permissions } = state;
  const navigate = useNavigate();
  const [sections, setSections] = useState([]);
  const [granted, setGranted] = useState([]);
  const extractPermissions = () => {
    const extracted = permissions?.filter((perms) => perms.module === "Badges");
    if (extracted) {
      setGranted(extracted);
    }
  };

  const getData = async () => {
    const res = await getHomePageData();
    if (res?.data?.success && res?.data?.data) {
      setSections(res.data.data);
    } else {
      handleErrors(res, navigate);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <DashboardLayout>
      <div>
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a>Management</a>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "#8b8b8cbf" }}
                  >
                    Home Page
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <HomePageList sections={sections} setSections={setSections} getData={getData} />
      </div>
    </DashboardLayout>
  );
}

export default Home_Page;
